<template>
	<div class="content-i">
		<div class="content-box">
      <div class="row mt-sm-2">
        <div class="col-sm-12 col-md-6 col-lg-12">
          <div class="element-wrapper">
            <h6 class="element-header">{{ t('emailVariablesText', 'emailVariablesText') }}</h6>
            <b-card class="col-lg-12">
              <b-tabs>
                <b-tab>
                  <template v-slot:title>
                    {{ t('editVariablesText', 'editVariablesText') }}
                  </template>
                  <EditVariables ref="editVarChild"></EditVariables>
                </b-tab>
                <b-tab>
                  <template v-slot:title>
                    {{ t('editContentsText', 'editContentsText') }}
                  </template>
                  <EditContents ref="editContentsChild"></EditContents>
                </b-tab>
              </b-tabs>
            </b-card>
          </div>
        </div>
      </div>
    </div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ResponseInfo from '@/components/ResponseInfo.vue'
import EditVariables from '@/components/Email_Variables/EditVariables.vue'
import EditContents from '@/components/Email_Variables/EditContents.vue'

export default {
	name: 'EmailVariables',
	components: {
		ResponseInfo,
		EditVariables,
		EditContents
	}
}
</script>

<style scoped>

</style>